"use client";

import React, { useState } from "react";

const Tooltip = ({ text, children }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            className="relative inline-block"
        >
            {children}
            {visible && (
                <div className="absolute right-full top-1/2 z-10 mr-2 -translate-y-1/2 transform rounded bg-gray-800 px-2 py-1 text-sm text-white whitespace-nowrap">
                    {text}
                </div>
            )}
        </div>
    );
};

export default function Speeddial({ actionButtons }) {
    const getGlassyClasses = () => {
        return "backdrop-filter backdrop-blur-xl bg-white border border-white rounded-xl shadow-lg transition-all duration-300";
    };

    return (
        <div className="z-50 fixed bottom-16 right-2 lg:right-3 lg:bottom-28 flex flex-col items-center gap-3">
            {actionButtons.map((action, index) => (
                <Tooltip text={action.label} key={index}>
                    <button
                        onClick={action.action}
                        className={`${getGlassyClasses()} flex items-center p-3 text-gray-800 hover:bg-slate-100`}
                    >
                        {action.icon}
                    </button>
                </Tooltip>
            ))}
        </div>
    );
}
